import React from 'react';
import ReactDOM from 'react-dom/client';

import garieli from './garieli.jpg';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <div>
      <div
        style={{
          position: 'relative',
          backgroundImage: `url(${garieli})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'white',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            background: 'rgba(0, 0, 0, 0.4)',
            padding: '2rem',
            borderRadius: '1rem',
            maxWidth: '600px',
          }}
        >
          <h1
            style={{
              fontSize: '2rem',
              fontWeight: 700,
              marginBottom: '1rem',
            }}
          >
            ვებგვერდი განახლების პროცესშია
          </h1>
          <p
            style={{
              fontSize: '1.2rem',
            }}
          >
            მალე აღდგება. გმადლობთ მოთმინებისთვის!
          </p>
        </div>
      </div>
    </div>
  </React.StrictMode>
);


